import { hasAnalyticsConsent } from "./consent";

const GA4_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const GA4_SCRIPT_ID = "slam-ga4-script";

let gaInitialized = false;

const loadGaScript = () => {
  if (document.getElementById(GA4_SCRIPT_ID)) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.id = GA4_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load GA4 script"));
    document.head.appendChild(script);
  });
};

const initializeAnalytics = async () => {
  if (!GA4_MEASUREMENT_ID || !hasAnalyticsConsent()) {
    return false;
  }

  if (!gaInitialized) {
    try {
      await loadGaScript();
    } catch {
      return false;
    }
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("consent", "default", {
    analytics_storage: "granted",
  });
  window.gtag("config", GA4_MEASUREMENT_ID, {
    anonymize_ip: true,
    send_page_view: false,
  });

  if (!gaInitialized) {
    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href,
      page_path: window.location.pathname,
    });
  } else {
    window.gtag("consent", "update", {
      analytics_storage: "granted",
    });
  }

  gaInitialized = true;
  return true;
};

const trackAnalyticsEvent = async (eventName, eventParams = {}) => {
  if (!eventName || !hasAnalyticsConsent()) {
    return;
  }

  if (typeof window.gtag !== "function") {
    await initializeAnalytics();
  }

  if (typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", eventName, eventParams);
};

export { initializeAnalytics, trackAnalyticsEvent };